import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { getMe } from '../../../redux/user/actions';
import Auth0LockService from '../../../services/AuthService/Auth0LockService';
import { getTenantFromUrl } from '../../../utils/urlHelper';

export class LoginPageComponent extends React.Component {
  componentDidMount() {
    if (!this.props.auth.isAuthenticated) {
      Auth0LockService.login();
    } else if (!getTenantFromUrl()) {
      this.props.getMe({ isLoginRequest: true });
    } else {
      this.props.getMe({ isLoginRequest: false });
      this.props.history.push({ pathname: window.localStorage.getItem('redirect') || '/' });
      window.localStorage.removeItem('redirect');
    }
  }

  render() {
    return (
      <div />
    );
  }
}

LoginPageComponent.propTypes = {
  auth: PropTypes.shape({ isAuthenticated: PropTypes.bool.isRequired }).isRequired,
  getMe: PropTypes.func.isRequired,
  history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
};

export const mapStateToProps = (state) => ({ auth: state.auth });

export const mapDispatchToProps = (dispatch) => ({ getMe: (options) => dispatch(getMe(options)) });

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(LoginPageComponent));
